import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter your email address.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      // ✅ Call your backend API
      const response = await fetch("https://meetra-green-energy-backend.onrender.com/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ Password reset link has been sent to your email!");
        navigate("/login");
      } else {
        setMessage(data.error || "Failed to send email.");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 style={{ textAlign: "center", color: "#0b3b5c", marginBottom: "20px" }}>Reset Password</h2>
        <p style={{ textAlign: "center", color: "#666", fontSize: "14px", marginBottom: "20px" }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleReset}>
          <div className="form-group">
            <input 
              type="email" 
              placeholder="Enter your email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
            />
          </div>
          
          {message && <p style={{ color: "red", textAlign: "center", fontSize: "13px" }}>{message}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <button 
          type="button" 
          onClick={() => navigate("/login")} 
          style={{ marginTop: "15px", background: "transparent", border: "none", color: "#666", cursor: "pointer", width: "100%" }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}